import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Button, Icon, COLORS, Tooltip } from 'Permafrost/index';
import { StyledDragDropListItem } from './OldDragDropList.styles';
export const DragDropListItem = ({ arrows, canDelete, className, index, isDragging, item, listLength, disableDeleteTooltipText, onDelete, 
// onEdit,
updateItemOrder, }) => {
    // tracks whether an arrow has been pressed on this item
    const [active, setActive] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    useEffect(() => {
        setActive(false);
    }, [index]);
    return (React.createElement(StyledDragDropListItem, { className: classNames(className, {
            dragging: isDragging,
            active,
        }), style: {
            backgroundColor: confirmDelete ? `${COLORS.oxfordBlue}80` : `${COLORS.oxfordBlue}`,
        } },
        React.createElement("div", { className: "list-item-text", style: {
                color: confirmDelete ? `${COLORS.defaultFontColor}80` : `${COLORS.defaultFontColor}`,
            } }, item.name),
        !confirmDelete && (React.createElement("div", { className: "list-buttons" },
            onDelete && canDelete ? (React.createElement(React.Fragment, null,
                disableDeleteTooltipText ? (React.createElement(Tooltip, { for: `delete-container-${item.id}` },
                    React.createElement("p", null, disableDeleteTooltipText))) : null,
                React.createElement("div", { "data-for": `delete-container-${item.id}`, "data-tip": true, "data-testid": `div--delete-btn-${item.name}` },
                    React.createElement(Button, { className: "delete", onClick: () => setConfirmDelete(true), disabled: !!disableDeleteTooltipText },
                        React.createElement(Icon, { name: "trash", size: [18] }))))) : null,
            arrows && (React.createElement(React.Fragment, null,
                React.createElement(Button, { "aria-label": "move item up", className: "arrow-up", disabled: index === 0, onClick: () => {
                        setActive(true);
                        updateItemOrder({ destination: index--, source: index });
                    } },
                    React.createElement(Icon, { name: "fa-arrow-up", size: [22] })),
                React.createElement(Button, { "aria-label": "move item down", className: "arrow-down", disabled: index === listLength - 1, onClick: () => {
                        setActive(true);
                        updateItemOrder({ destination: index++, source: index });
                    } },
                    React.createElement(Icon, { name: "fa-arrow-down", size: [22] })))))),
        confirmDelete && onDelete && canDelete ? (React.createElement("div", { className: "confirm-delete-container" },
            React.createElement("p", null, "Are you sure?"),
            React.createElement(Button, { "data-testid": `btn--confirm-delete-label`, className: "confirm", onClick: () => onDelete(item.id), style: { opacity: isDragging ? '0.5' : '' } }, "Yes, Delete It"),
            React.createElement(Button, { "data-testid": `btn--decline-delete-label`, className: "cancel", onClick: () => setConfirmDelete(false), style: { opacity: isDragging ? '0.5' : '' } }, "No, Keep It"))) : null));
};
//# sourceMappingURL=OldDragDropListItem.js.map